<h2>Finalizar saneamento</h2>
<p>Gere os documentos, confira os anexos e mantenha a capa na primeira posição.</p>
<p class="erro" role="alert" *ngIf="erro">{{ erro }}</p>
<p role="status" *ngIf="mensagem">{{ mensagem }}</p>
<div class="acoes">
  <button type="button" [disabled]="carregando" (click)="gerar('FICHA_FUNCIONAL')">Gerar Ficha Funcional</button>
  <button type="button" [disabled]="carregando" (click)="gerar('QTC')">Gerar Quadro Tempo Contribuição</button>
  <button type="button" [disabled]="carregando" (click)="gerar('ASCENSAO_FUNCIONAL')">Gerar Ascensão Funcional</button>
  <button type="button" [disabled]="carregando" (click)="gerar('CAPA')">Gerar Capa</button>
  <button type="button" [disabled]="carregando || !estado.pecas.length" (click)="ordenar()">Ordenar Processo</button>
</div>
<p *ngIf="carregando" role="status">Processando…</p>
<table>
  <thead><tr><th>Ordem</th><th>Documento</th><th>Páginas</th><th>Arquivo</th><th>Ações</th></tr></thead>
  <tbody><tr *ngFor="let peca of estado.pecas; let i = index">
    <td>{{ i + 1 }}</td><td>{{ peca.nome }}</td><td>{{ peca.paginas }}</td>
    <td>{{ peca.assinado ? 'Original assinado' : 'Documento sem assinatura' }}</td>
    <td><button type="button" [disabled]="carregando || i === 0" (click)="mover(i, -1)" aria-label="Mover documento para cima">↑</button>
      <button type="button" [disabled]="carregando || i === estado.pecas.length - 1" (click)="mover(i, 1)" aria-label="Mover documento para baixo">↓</button>
      <button type="button" (click)="baixarPeca(peca)">Baixar peça</button></td>
  </tr></tbody>
</table>
<p *ngIf="!estado.pecas.length && !carregando">Nenhuma peça disponível para montagem.</p>
<h3>Versões do processo</h3>
<p>O PDF reunido é uma cópia para consulta. Preserve os arquivos originais assinados, disponíveis individualmente nas peças.</p>
<ul><li *ngFor="let versao of estado.versoes">
  Versão {{ versao.versao }} — {{ versao.paginas }} páginas — {{ versao.criadoEm | date:'dd/MM/yyyy HH:mm' }}
  <button type="button" (click)="baixarVersao(versao.versao)">Baixar processo</button>
  <button type="button" (click)="verPecas(versao.versao)">Ver peças da versão</button>
</li></ul>

<div *ngIf="versaoHistorica !== null">
  <h3>Peças originais da versão {{ versaoHistorica }}</h3>
  <ul><li *ngFor="let peca of pecasHistoricas; let i = index">
    {{ peca.nome }} — página inicial {{ peca.paginaInicial }} — {{ peca.paginas }} página(s)
    <button type="button" (click)="baixarPecaHistorica(i)">Baixar original desta versão</button>
  </li></ul>
</div>
